module.exports = __webpack_public_path__ + "img/bloody-kirby.3ea98f9d.jpg";